import { CalendarDays, Check, FileText, Phone, ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function HowItWorks() {
    const { t } = useTranslation();
    const icons = [ShieldCheck, CalendarDays, FileText];
    return (
        <section id="how-it-works" className="landing-section landing-how" aria-labelledby="how-title">
            <div className="landing-container">
                <div className="landing-section-heading landing-centered">
                    <p className="landing-eyebrow">{t('howItWorks.badge')}</p>
                    <h2 id="how-title">{t('howItWorks.title')}</h2>
                    <p>{t('howItWorks.subtitle')}</p>
                </div>
                <ol className="landing-steps">
                    {icons.map((Icon, index) => <li key={index}>
                        <div className="landing-step-top"><span className="landing-step-icon"><Icon size={22} strokeWidth={1.7} aria-hidden="true" /></span><span className="landing-step-number">0{index + 1}</span></div>
                        <h3>{t(`howItWorks.step${index + 1}.title`)}</h3>
                        <p>{t(`howItWorks.step${index + 1}.desc`)}</p>
                        <div className="landing-step-detail">
                            {index === 0 ? <Phone size={14} aria-hidden="true" /> : <Check size={15} aria-hidden="true" />}
                            {t(`howItWorks.step${index + 1}.detail`)}
                        </div>
                    </li>)}
                </ol>
            </div>
        </section>
    );
}
